import script from "./OperationPortDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationPortDetails.vue?vue&type=script&setup=true&lang=js"

import "./OperationPortDetails.vue?vue&type=style&index=0&id=39e2d78a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e2d78a"]])

export default __exports__